module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor has-text-centered"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title "
  }, [_vm._v("File Upload")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.$upload.meta('file-upload').status === 'sending'
    },
    on: {
      "click": function($event) {
        _vm.$upload.select('file-upload')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$upload.meta('file-upload').status === 'sending'),
      expression: "$upload.meta('file-upload').status === 'sending'"
    }]
  }, [_vm._v("Uploading...")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$upload.meta('file-upload').status != 'sending'),
      expression: "$upload.meta('file-upload').status != 'sending'"
    }]
  }, [_vm._v("Select")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.$upload.meta('file-upload').status === 'sending'
    },
    on: {
      "click": function($event) {
        _vm.$upload.reset('file-upload')
      }
    }
  }, [_vm._v("\n            Clear\n          ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('progress-bar', {
    attrs: {
      "type": 'success',
      "value": _vm.$upload.meta('file-upload').percentComplete,
      "max": 100
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$upload.errors('file-upload').length) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v("\n          " + _vm._s(_vm.$upload.errors('file-upload')[0].message) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.$upload.files('file-upload').all.length) ? _c('div', [_vm._v("\n            No uploads here yet.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.$upload.files('file-upload').progress), function(file) {
    return _c('div', [_c('div', [_vm._v("\n              " + _vm._s(file.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: ('width: ' + file.percentComplete + '%;')
    }, [_vm._v("\n                " + _vm._s(file.percentComplete) + "%\n              ")])])])
  }), _vm._v(" "), _vm._l((_vm.$upload.files('file-upload').queued), function(file) {
    return _c('div', [_c('div', [_vm._v("\n              " + _vm._s(file.name) + "\n              "), _c('br'), _vm._v("\n              Queued for upload\n            ")])])
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$upload.files('file-upload').complete), function(file) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(file.name) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(file.status) + "\n              ")]), _vm._v(" "), (file.status == 'success') ? _c('td', [_c('a', {
      staticClass: "short-link",
      attrs: {
        "href": file.downurl,
        "data-label": "Copied"
      }
    }, [_vm._v("https://flb.st/" + _vm._s(file.randname))])]) : _c('td'), _vm._v(" "), (file.status == 'success') ? _c('td', [_vm._v(" " + _vm._s(file.percentComplete) + "%")]) : _c('td', _vm._l((file.errors), function(filerror) {
      return _c('span', [_c('span', [_vm._v("  " + _vm._s(filerror.message) + " "), _c('br')])])
    }))])
  }))])], 2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Link")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0f27e7c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/admin/Upload.vue
// module id = 147
// module chunks = 34